import { AxInit, ModuleName } from '../../Lib/AxSystem/AxInit';
import { I18nHelper, Translations } from '../../Lib/Helper/I18nHelper';

@ModuleName("CategoryContainer")
export class CategoryContainer implements AxInit {
    private _desktopUrl: string = '/CategoryContainerMenu/Desktop';
    private _mobileUrl: string = '/CategoryContainerMenu/Mobile';
    private _breadCumb: string[] = [];
    private _selectedCategoryId: string = null;
    private _selectedCategoryName: string = null;
    private _selectedProductCategoryId: string = null;
    private _selectedProductCategoryName: string = null;
    private _hasOnlyOneCategory: boolean = false;
    private _hasOnlyOneProductCategory: boolean = false;
    constructor(private _i18nHelper = new I18nHelper()) { }

    AxInit(init) {
        $('div.ax-header').on('mouseenter', 'li.ax-nav-item', (e: JQuery.MouseEnterEvent<HTMLElement>) => {
            e.preventDefault();

            //Selected different then tickets nav li don't show
            if ($(e.currentTarget).attr('data-nav-desktop-tickets') == undefined) {
                return;
            } 

            //If already loaded, do not load again
            if ($('body').find('[data-main-container-desktop]').length > 0) {
                this.ToggleDesktopMenu(true);
                return;
            }

            AxessViewer.loadPartialView(this._desktopUrl, {},
                (res) => {
                    if (res?.success) {
                        $('body').append(res.view);
                        this.ToggleDesktopMenu(true);
                    }
                    else {
                        $('body').remove('[data-main-container-desktop]');
                    }
                }, { type: 'GET', silent: true }
            );
        });

        $('body').on('mouseleave', '[data-main-container-desktop]', (e: JQuery.MouseLeaveEvent<HTMLElement>) => {
            e.preventDefault();
            this.ToggleDesktopMenu(false);
        });

        $('body').on('mouseenter', '[data-category-container]', (e: JQuery.MouseEnterEvent<HTMLElement>) => {
            e.preventDefault();
            const categoryId = $(e.currentTarget).attr('data-category-id');
            this.ManageVisibilityByCategoryId(categoryId);
        });

        $('body').on('click touchstart', '[data-main-nav-mob]', (e: JQuery.ClickEvent<HTMLElement>) => {
            //If already loaded, do not load again
            if (!$('body').find('#data-main-container-mob').html().isEmpty()) {
                this.SetDefaults();
                return;
            }

            AxessViewer.loadPartialView(this._mobileUrl, {},
                (res) => {
                    if (res?.success) {
                        $('#data-main-container-mob').append(res.view);
                        this.SetDefaults();
                    }
                    else {
                        $('#data-main-container-mob').empty();
                    }
                }, { type: 'GET', silent: true }
            );
        });

        $('body').on('click', '[data-category-container-mob]', (e: JQuery.ClickEvent<HTMLElement>) => {
            e.preventDefault();
            const categoryId = $(e.currentTarget).attr('data-category-id');
            const categoryName = $(e.currentTarget).attr('data-category-name');
            this.DivEffect(() => {
                $('[data-category-container-mob], [data-product-category-container-mob]').addClass('d-none');
                $(`[data-product-category-container-mob][data-category-id="${categoryId}"]`).removeClass('d-none');
                this.AddBreadCumb(categoryName);
            });
            this._selectedCategoryId = categoryId;
            this._selectedCategoryName = categoryName;
        });

        $('body').on('click', '[data-product-category-container-mob]', (e: JQuery.ClickEvent<HTMLElement>) => {
            e.preventDefault();
            const productCategoryId = $(e.currentTarget).attr('data-product-category-id');
            const productCategoryName = $(e.currentTarget).attr('data-product-category-name');
            this.DivEffect(() => {
                $('[data-product-category-container-mob], [data-product-container-mob]').addClass('d-none');
                $(`[data-product-container-mob][data-product-category-id="${productCategoryId}"]`).removeClass('d-none');
                this.AddBreadCumb(productCategoryName);
            });
            this._selectedProductCategoryId = productCategoryId;
            this._selectedProductCategoryName = productCategoryName;
        });

        $('body').on('click', '[data-back-btn]', (e: JQuery.ClickEvent<HTMLElement>, breadCumbTarget = null) => {
            e.preventDefault();
            if (!this._selectedCategoryId && !this._selectedProductCategoryId && !breadCumbTarget) {
                //Slide to Menu
                this.ToggleMobileMenu('left');
                return;
            }

            //If has no bread cumb target (clicked btn-back -> normal behavior):
            // - target (breadCumb[last])
            //Otherwise (simulated btn back -> bread cumb behavior):
            // - target (breadCumb[indexOf(target) + 1])
            let target = breadCumbTarget == null
                ? this._breadCumb[this._breadCumb.length - 1]
                : this._breadCumb[this._breadCumb.indexOf(breadCumbTarget) + 1];

            if (target == this._selectedProductCategoryName) {
                this._selectedProductCategoryId = null;
                this._selectedProductCategoryName = null;
                //Go back to tickets
                if (this._hasOnlyOneCategory && this._hasOnlyOneProductCategory) {
                    this.ToggleMobileMenu('left');
                }
                //Go back to product categories
                else {
                    this.DivEffect(() => {
                        $('[data-product-container-mob], [data-product-category-container-mob]').addClass('d-none');
                        $(`[data-product-category-container-mob][data-category-id="${this._selectedCategoryId}"]`).removeClass('d-none');
                        this.RemoveBreadCumb(breadCumbTarget);
                    });
                }
            }
            else if (target == this._selectedCategoryName || target == this._i18nHelper.GetTranslation(Translations.Tickets)) {
                this._selectedCategoryId = null;
                this._selectedCategoryName = null;
                //edge case bread cumb behavior "jumps" to 1st level
                //delete manually selected product category data
                this._selectedProductCategoryId = null;
                this._selectedProductCategoryName = null;
                //Go back to tickets
                if (this._hasOnlyOneCategory) {
                    this.ToggleMobileMenu('left');
                }
                //Go back to categories
                else {
                    this.DivEffect(() => {
                        $('[data-product-category-container-mob], [data-product-container-mob]').addClass('d-none');
                        $('[data-category-container-mob]').removeClass('d-none');
                        this.RemoveBreadCumb(breadCumbTarget);
                    });
                }
            }
        });

        $('body').on('click', '[data-bread-cumb-caption]', (e: JQuery.ClickEvent<HTMLElement>) =>
        {
            e.preventDefault();
            const target = $(e.currentTarget).text().replace(/ \/ /g, '');
            //Send next element as target name to event button back event
            $('[data-back-btn]').trigger('click', target);
        });
    }

    ToggleMobileMenu(direction: string) {
        if (direction == 'left') {
            $('#data-main-container-mob').toggleClass('ax-slide-right');
        }
        else {
            $('#data-main-container-mob').toggleClass('ax-slide-left');
        }

        $('#data-main-container-mob').toggleClass('ax-slide-x');
    }

    ToggleDesktopMenu(visible: boolean) {
        $('[data-main-container-desktop]').toggleClass('d-none', !visible);

        //Manage aria for menu
        $('[data-nav-desktop-tickets]')?.attr('aria-expanded', visible.toString().toLowerCase());
        $('[data-main-container-desktop]').attr('aria-hidden', (!visible).toString().toLowerCase());

        let categoryId = null;
        if (visible) {
            // case Categories > 1 find for active category id or set the first.
            if ($('[data-category-container]').length > 0) {
                categoryId = $('[data-category-container]').hasClass('active')
                    ? $('[data-category-container]').attr('data-category-id')
                    : $('[data-category-container]').first().attr('data-category-id');
            }
            // case Categories = 1 (there is no data-category-container rendered) find the first in data-product-category-container
            else {
                categoryId = $('[data-product-category-container]').first().attr('data-category-id')
            }
        }

        this.ManageVisibilityByCategoryId(categoryId);
    }

    ManageVisibilityByCategoryId(categoryId: string) {
        //Unset active and manage aria hidden (data-category-container level)
        $('[data-category-container]')?.removeClass('active').attr('aria-hidden', 'true');
        //Unset visible and manage aria hidden (data-product-category-container level)
        $('[data-product-category-container]').addClass('d-none').attr('aria-hidden', 'true');
        //Unset visible and manage aria hidden (data-product-category level)
        $('[data-product-category-container]').find('[data-product-category]').addClass('d-none').attr('aria-hidden', 'true');
        //Unset visible and manage aria hidden (.product-container level)
        $('[data-product-category-container]').find('[data-product-category]').find('.product-container').addClass('d-none').attr('aria-hidden', 'true');

        if (categoryId) {
            //Set active and manage aria hidden (data-category-container level)
            $(`[data-category-container][data-category-id="${categoryId}"]`)?.addClass('active').attr('aria-hidden', 'false');
            //Set visible and manage aria hidden (data-product-category-container level)
            $(`[data-product-category-container][data-category-id="${categoryId}"]`).removeClass('d-none').attr('aria-hidden', 'false');
            //Set visible and manage aria hidden (data-product-category level)
            $(`[data-product-category-container][data-category-id="${categoryId}"`).find('[data-product-category]').removeClass('d-none').attr('aria-hidden', 'false');
            //Set visible and manage aria hidden (.product-container level)
            $(`[data-product-category-container][data-category-id="${categoryId}"`).find('[data-product-category]').find('.product-container').removeClass('d-none').attr('aria-hidden', 'false');
        }
    }

    DivEffect(callback) {
        $('#data-main-container-mob').animate({ width: 'hide' }, callback);
        $('#data-main-container-mob').animate({ width: 'show' });
    }

    SetDefaults() {
        this._hasOnlyOneCategory = $('[data-category-container-mob]').length == 1;
        this._hasOnlyOneProductCategory = $('[data-product-category-container-mob]').length == 1;

        this.SetDefaultsSelection(this._hasOnlyOneCategory, this._hasOnlyOneProductCategory);
        this.SetDefaultBreadCumb(this._hasOnlyOneCategory, this._hasOnlyOneProductCategory);
        this.SetDefaultVisibility(this._hasOnlyOneCategory, this._hasOnlyOneProductCategory);
        this.RenderBreadCumb();
    }

    SetDefaultsSelection(hasOnlyOneCategory: boolean, hasOnlyOneProductCategory: boolean) {
        if (hasOnlyOneCategory) {
            this._selectedCategoryId = $('[data-category-container-mob]').first().attr('data-category-id');
            this._selectedCategoryName = $('[data-category-container-mob]').first().attr('data-category-name');
        }

        if (hasOnlyOneProductCategory) {
            this._selectedProductCategoryId = $('[data-product-category-container-mob]').first().attr('data-product-category-id');
            this._selectedProductCategoryName = $('[data-product-category-container-mob]').first().attr('data-product-category-name');
        }

        if (!hasOnlyOneCategory && !hasOnlyOneProductCategory) {
            this._selectedCategoryId = null;
            this._selectedCategoryName = null;
            this._selectedProductCategoryId = null;
            this._selectedProductCategoryName = null;
        }
    }

    SetDefaultBreadCumb(hasOnlyOneCategory: boolean, hasOnlyOneProductCategory: boolean) {
        if (!hasOnlyOneCategory) {
            this._breadCumb = [this._i18nHelper.GetTranslation(Translations.Tickets)];
            return;
        }

        if (hasOnlyOneProductCategory) {
            this._breadCumb = [$('[data-product-category-container-mob]').first().attr('data-product-category-name')];
        }
        else {
            this._breadCumb = [$('[data-category-container-mob]').first().attr('data-category-name')];
        }

        return;
    }

    SetDefaultVisibility(hasOnlyOneCategory: boolean, hasOnlyOneProductCategory: boolean) {
        let hiddenDivs = [];
        let visibleDiv = '';

        if (!hasOnlyOneCategory) {
            hiddenDivs.push('[data-product-category-container-mob]');
            hiddenDivs.push('[data-product-container-mob]');
            visibleDiv ='[data-category-container-mob]';
        }
        else if (!hasOnlyOneProductCategory) {
            hiddenDivs.push('[data-category-container-mob]');
            hiddenDivs.push('[data-product-category-container-mob]');
            visibleDiv = '[data-product-category-container-mob]';
        }
        else {
            hiddenDivs.push('[data-category-container-mob]');
            hiddenDivs.push('[data-product-category-container-mob]');
            visibleDiv = '[data-product-container-mob]';
        }

        $(`${hiddenDivs.join(',')}`).addClass('d-none');
        $(`${visibleDiv}`).removeClass('d-none');
    }

    RenderBreadCumb() {
        const $breadCumbContainer = $('[data-bread-cumb-container]')
        const $emptyBreadCumbCaption = $('[data-bread-cumb-hidden]').find('[data-bread-cumb-caption]');
        const $emptyBreadCumbCaptionActive = $('[data-bread-cumb-hidden]').find('[data-bread-cumb-caption-active]');
        //clean container
        $($breadCumbContainer).empty();

        //add data-bread-cum-caption items (breadCumb array but lastElement)
        for (let i = 0; i < this._breadCumb.length - 1; i++) {
            let $newCaption = $emptyBreadCumbCaption.clone();
            $newCaption.text(`${this._breadCumb[i]} / `);
            $($breadCumbContainer).append($newCaption);
        }

        const lastElement = this._breadCumb[this._breadCumb.length - 1];
        //add data-bread-cum-caption-active item (lastElement)
        let $newCaptionActive = $emptyBreadCumbCaptionActive.clone();
        $newCaptionActive.text(` ${lastElement}`);
        $($breadCumbContainer).append($newCaptionActive);
    }

    AddBreadCumb(item: string) {
        this._breadCumb.push(item);
        this.RenderBreadCumb();
    }

    //If item is null remove last, otherwise remove tail elements until find it.
    RemoveBreadCumb(item: string = null) {
        if (!item) {
            this._breadCumb.pop();
        }
        else {
            for (let i = this._breadCumb.length - 1; i > 0; i--) {
                if (item != this._breadCumb[i]) {
                    this._breadCumb.pop();
                }
            }
        }

        this.RenderBreadCumb();
    }
}